import { MutationTree } from 'vuex';
import { IDevicesState } from '../types';
import { DeviceInfo, IFileTransferProgressEvent } from '@/common/apis/DeviceApi';
import Vue from 'vue';

export const mutations: MutationTree<IDevicesState> = {
    setLoading(state, loading: boolean) {
        Vue.set(state, 'loading', loading);
    },
    loaded(state, devices: DeviceInfo[]) {
        Vue.set(state, 'loading', false);
        for (const device of devices) {
            if (device.number !== undefined) {
                Vue.set(state.devices, device.number, device);
            }

            // Clear resetted device
            if (state.resettedDevice && state.resettedDevice === device.number && !device.owner) {
                Vue.set(state, 'resettedDevice', undefined);
            }
        }
    },
    clear(state) {
        state.devices = {};
        state.loading = false;
        state.progress = {};
    },
    deviceChanged(state, device: DeviceInfo) {
        if (device.number) {
            Vue.set(state.devices, device.number, device);
        }

        // Clear resetted device
        if (state.resettedDevice && state.resettedDevice === device.number && !device.owner) {
            Vue.set(state, 'resettedDevice', undefined);
        }
    },
    nameUpdated(state, args: {deviceNumber: string, name: string}) {
        const device = state.devices[args.deviceNumber];
        if (device) {
            Vue.set(device, 'name', args.name);
        }
    },
    progress(state, args: IFileTransferProgressEvent) {
        if (args.deviceNumber) {
            Vue.set(state.progress, args.deviceNumber, args);
        }
    },
    resetProgress(state, deviceNumber: string) {
        Vue.set(state.progress, deviceNumber, null);
    },
    setResettedDevice(state, deviceNumber: string) {
        Vue.set(state, 'resettedDevice', deviceNumber);
    },
};
